import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { BETRIEBSHINWEISE_PATH } from '@mcikm-vote/shared';
import type { BetriebshinweiseAntwort } from '@mcikm-vote/shared';

import { apiAnfrage } from '../api/anfrage';
import type { ApiFehler } from '../api/anfrage';

/**
 * Betriebshinweise des Administrationsbereichs (§25.5, §35.3).
 *
 * Wird von der Hülle abgefragt und gilt damit auf jeder Adminseite: Ein unerwarteter Neustart
 * soll auffallen, gleich wo man gerade ist.
 */

export const HINWEISE_SCHLUESSEL = ['admin', 'hinweise'] as const;

export function useBetriebshinweise(
  aktiv: boolean,
): UseQueryResult<BetriebshinweiseAntwort, ApiFehler> {
  return useQuery<BetriebshinweiseAntwort, ApiFehler>({
    queryKey: HINWEISE_SCHLUESSEL,
    queryFn: () => apiAnfrage<BetriebshinweiseAntwort>(BETRIEBSHINWEISE_PATH),
    enabled: aktiv,
  });
}

/** Bestätigt den Neustarthinweis (§35.3). Der Protokolleintrag bleibt unberührt. */
export function useNeustartBestaetigen(): UseMutationResult<void, ApiFehler, void> {
  const queryClient = useQueryClient();

  return useMutation<void, ApiFehler, void>({
    mutationFn: () =>
      apiAnfrage<void>(`${BETRIEBSHINWEISE_PATH}/neustart-bestaetigen`, { methode: 'POST' }),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: HINWEISE_SCHLUESSEL });
    },
  });
}
